import './Contact.css';
import { useForm } from 'react-hook-form';
import Options from './Options.json';
import { FiMapPin } from 'react-icons/fi';
import { IoMailOutline } from 'react-icons/io5';
import { LuCircleAlert } from 'react-icons/lu';
import { toast } from 'react-toastify';
import API from '../../../Utils/api';
import Reveal from '../shared/Reveal';

function FieldError({ id, children }) {
    return (
        <p id={id} className='lp-field-error' role='alert'>
            <LuCircleAlert aria-hidden='true' /> {children}
        </p>
    );
}

export default function Contact() {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors, isSubmitting }
    } = useForm({ mode: 'onBlur' });

    const onSubmit = async data => {
        try {
            await API.addFeedback({ ...data, type: 'Contact' });
            reset();
            toast.success('Thank you for contacting us!', {
                position: 'bottom-center'
            });
        } catch {
            toast.error(`Couldn't send the feedback!`, {
                position: 'bottom-center'
            });
        }
    };

    return (
        <section id='contact' className='lp-section lp-contact lp-tint'>
            <div className='lp-wrap'>
                <Reveal>
                    <p className='lp-eyebrow'>{Options.Title}</p>
                    <h2 className='lp-h2'>Talk to the team.</h2>
                    <p className='lp-lede'>{Options.Subtitle}</p>
                </Reveal>

                <Reveal className='lp-contact-grid' delay={100}>
                    <div className='lp-contact-side'>
                        <ul className='lp-contact-info'>
                            <li>
                                <FiMapPin aria-hidden='true' />
                                <div>
                                    <h3>Address</h3>
                                    <p>{Options.Address}</p>
                                </div>
                            </li>
                            <li>
                                <IoMailOutline aria-hidden='true' />
                                <div>
                                    <h3>Email</h3>
                                    <p>{Options.Email}</p>
                                </div>
                            </li>
                        </ul>
                        <iframe
                            title='Map of Athens, Greece'
                            src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d50310.60044109002!2d23.73833935!3d37.9908372!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a1bd1f067043f1%3A0x2736354576668ddd!2sAthens%2C%20Greece!5e0!3m2!1sen!2suk!4v1706572007927!5m2!1sen!2suk'
                            allowFullScreen
                            loading='lazy'
                            referrerPolicy='no-referrer-when-downgrade'
                        ></iframe>
                    </div>

                    <form onSubmit={handleSubmit(onSubmit)} className='lp-form' noValidate>
                        <div className='lp-field'>
                            <label htmlFor='name'>Name</label>
                            <input
                                type='text'
                                id='name'
                                autoComplete='name'
                                placeholder='Your name'
                                aria-describedby={errors.name ? 'name-error' : 'name-help'}
                                aria-invalid={errors.name ? 'true' : 'false'}
                                {...register('name', { required: 'This field is required' })}
                            />
                            <p id='name-help' className='lp-field-help'>How we should address you.</p>
                            {errors.name && <FieldError id='name-error'>{errors.name.message}</FieldError>}
                        </div>
                        <div className='lp-field'>
                            <label htmlFor='email'>Email</label>
                            <input
                                type='email'
                                id='email'
                                autoComplete='email'
                                placeholder='you@example.com'
                                aria-describedby={errors.email ? 'email-error' : 'email-help'}
                                aria-invalid={errors.email ? 'true' : 'false'}
                                {...register('email', {
                                required: 'This field is required',
                                pattern: {
                                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                    message: 'That email address does not look right.'
                                }
                            })}
                            />
                            <p id='email-help' className='lp-field-help'>Where we can reply.</p>
                            {errors.email && <FieldError id='email-error'>{errors.email.message}</FieldError>}
                        </div>
                        <div className='lp-field lp-field-wide'>
                            <label htmlFor='subject'>Subject</label>
                            <input
                                type='text'
                                id='subject'
                                placeholder='What is this about?'
                                aria-describedby={errors.subject ? 'subject-error' : 'subject-help'}
                                aria-invalid={errors.subject ? 'true' : 'false'}
                                {...register('subject', { required: 'This field is required' })}
                            />
                            <p id='subject-help' className='lp-field-help'>A few words is enough.</p>
                            {errors.subject && <FieldError id='subject-error'>{errors.subject.message}</FieldError>}
                        </div>
                        <div className='lp-field lp-field-wide'>
                            <label htmlFor='message'>Message</label>
                            <textarea
                                id='message'
                                rows='5'
                                placeholder='Write your message'
                                aria-describedby={errors.message ? 'message-error' : 'message-help'}
                                aria-invalid={errors.message ? 'true' : 'false'}
                                {...register('message', { required: 'This field is required' })}
                            ></textarea>
                            <p id='message-help' className='lp-field-help'>Tell us what you need or what went wrong.</p>
                            {errors.message && <FieldError id='message-error'>{errors.message.message}</FieldError>}
                        </div>
                        <div className='lp-field-wide'>
                            <button type='submit' className='lp-btn' disabled={isSubmitting}>
                                {isSubmitting ? 'Sending' : 'Send Message'}
                            </button>
                        </div>
                    </form>
                </Reveal>
            </div>
        </section>
    );
}
